/**
 * Created by danie on 2021/03/02.
 * 浏览器存储的cookie,store使用
 */
export default ['token', 'roleId', 'refreshToken', 'chat', 'userInfo']
